export default __webpack_public_path__ + "static/media/landing-slider-image-5.daced4c3.png";